import {
	Container, DataService, Service, TrackingEventNames, TrackingService,
} from '../../../symphony';
import { AIChatPlaygroundStore } from '../AIChatPlaygroundStore';
import { ClickType, ResetClickType, aIChatPlaygroundContext } from '../aIChatPlaygroundConstants';
import { ErrorStatusCodes, TrackingWarningMessages } from '../aIChatPlaygroundInterface';

@Service()
export class AIChatPlaygrountTrackingService {
	private trackingServie = Container.take(aIChatPlaygroundContext.value, TrackingService);  

	private globalDataService = Container.take('global', DataService);

	private store = Container.take(aIChatPlaygroundContext.value, AIChatPlaygroundStore);

	private getWarningMessageByStatusCode = (statusCode: ErrorStatusCodes) => {
		switch (statusCode) {
		case ErrorStatusCodes.InternalServerError:
			return TrackingWarningMessages.SomethingWentWrong;
		case ErrorStatusCodes.PromptTooLong:
			return TrackingWarningMessages.PromptTooLong;
		case ErrorStatusCodes.LimitReached:
			return TrackingWarningMessages.LimitReached;
		case ErrorStatusCodes.ChatGptError:
			return TrackingWarningMessages.AiError;
		default:
			return TrackingWarningMessages.SomethingWentWrong;
		}
	};

	public trackPlaygroundClick = (clickType: ClickType) => {
		this.trackingServie.tracking$.next({
			eventName: TrackingEventNames.aiPlaygroundScreenClick,
			eventParams: {
				clickType,
				dynamicId: String(this.store.materialHeader.value.dynamicId || ''),
				materialId: String(this.store.materialHeader.value.materialId || ''),
				staticId: String(this.store.materialHeader.value.staticId || ''),
				experienceAlias: this.globalDataService.learningExperience$?.value?.alias,
				experienceTypeId: this.globalDataService.learningExperience$?.value?.typeId?.toString(),
				version: '2-0-0',
			},
		});
	};

	public trackPlaygroundWarning = (statusCode: ErrorStatusCodes) => {
		this.trackingServie.tracking$.next({
			eventName: TrackingEventNames.aiPopupWarning,
			eventParams: {
				warningMessage: this.getWarningMessageByStatusCode(statusCode),
				dynamicId: String(this.store.materialHeader.value.dynamicId || ''),
				materialId: String(this.store.materialHeader.value.materialId || ''),
				staticId: String(this.store.materialHeader.value.staticId || ''),
				experienceAlias: this.globalDataService.learningExperience$?.value?.alias,
				experienceTypeId: this.globalDataService.learningExperience$?.value?.typeId?.toString(),
				version: '2-0-0',
			},
		});
	};

	public trackPlaygroundReset = (clickType: ResetClickType) => {
		this.trackingServie.tracking$.next({
			eventName: TrackingEventNames.aiResetChat,
			eventParams: {
				clickType,
				dynamicId: String(this.store.materialHeader.value.dynamicId || ''),
				materialId: String(this.store.materialHeader.value.materialId || ''),
				staticId: String(this.store.materialHeader.value.staticId || ''),
				experienceAlias: this.globalDataService.learningExperience$?.value?.alias,
				experienceTypeId: this.globalDataService.learningExperience$?.value?.typeId?.toString(),
				version: '2-0-0',
			},
		});
	};

	public trackPlaygroundSettingUpdate = () => {
		this.trackingServie.tracking$.next({
			eventName: TrackingEventNames.aiSettingsUpdated,
			eventParams: {
				parametersSettings: this.store.modelConfigs?.value?.map((config) => ({
					key: config?.key || '',
					value: config?.value?.toString() || '',
					source: 'user',
				})),
				conversationId: this.store.conversationId.value,
				dynamicId: String(this.store.materialHeader.value.dynamicId || ''),
				materialId: String(this.store.materialHeader.value.materialId || ''),
				staticId: String(this.store.materialHeader.value.staticId || ''),
				experienceAlias: this.globalDataService.learningExperience$?.value?.alias,
				experienceTypeId: this.globalDataService.learningExperience$?.value?.typeId?.toString(),
				version: '2-0-0',
			},
		});
	};
}
